import React, { Component } from 'react';
import { connect } from '@common/components/base.component';
import { OverlayTrigger, Tooltip as TooltipBootstrap } from 'react-bootstrap';
import navbarSelectors from '@common/store/navbar/navbar.selectors';

class NavbarSystems extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { systems } = this.props.navbarSelectors;

    return (
      <div className="application-container mr-2">
        <div className="all-application">
          <i className="fa fa-th" />
          <ul className="menu-application">
            {systems.map((item, index) => (
              <OverlayTrigger
                key={`top-${item.Name}`}
                placement={'top'}
                overlay={
                  <TooltipBootstrap id={`tooltip-${item.Name}`} style={{ zIndex: 999999 }}>
                    <div className={'fontTooltip'}>{item.Name}</div>
                  </TooltipBootstrap>
                }
              >
                <li key={index}>
                  <a href={item.Url} className={`module ${item.Class}-module`} />
                </li>
              </OverlayTrigger>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

export default connect({
  selectors: { navbarSelectors },
})(NavbarSystems);
